import { apiSlice } from "@/shared/api/api-slice"
import type { UploadDocumentRequest, UploadDocumentResponse } from "@/shared/types/api/business-mode.types"

export const createBusinessDocumentApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["BusinessDocumentsList"]
  })
  .injectEndpoints({
    endpoints: builder => ({
      createBusinessDocument: builder.mutation<UploadDocumentResponse, UploadDocumentRequest>({
        query: request => ({
          url: "/api/v1/business/documents",
          method: "POST",
          body: request
        }),
        invalidatesTags: () => [{ type: "BusinessDocumentsList" as const }]
      })
    })
  })

export const { useCreateBusinessDocumentMutation } = createBusinessDocumentApi
